import { useMemo } from "react";
import VersatileLink from "@/components/VersatileLink";

export default function TargetLink({ href, blank, className, children }) {
  const target = useMemo(() => {
    return blank ? "_blank" : "_self";
  }, [blank]);

  if (/^(https?:\/\/|\/).+/.test(href)) {
    //httpsがついていた場合新しいタブで開く
    return (
      <VersatileLink
        className={className}
        target={target}
        rel="noreferrer noopener"
        href={href}
      >
        {children}
      </VersatileLink>
    );
  } else {
    return <a className={className}>{children}</a>;
  }
}
